import type { ReactElement } from "react";

/**
 * ストレージの使用量（サーバの StorageGauge と同じ欄。Implem.Portal.Backend の docs/features/10）。
 * <b>文言も割合もサーバが作る。</b>画面は計算しない。
 */
export interface StorageUsage {
    /** 「0.03 GB / 10.1 GB（0%）」「使用量を確かめられません（上限 10.1 GB）」。サーバが作る。 */
    readonly label: string;
    /** 「0.03 GB」。分からなければ「—」。 */
    readonly usedLabel: string;
    /** 「10.1 GB」（初期容量＋追加ストレージ）。 */
    readonly limitLabel: string;
    /** 0〜100。分からなければ null。 */
    readonly percent: number | null;
    /** 90% 以上。 */
    readonly isNearLimit: boolean;
}

/**
 * 会員の契約情報と管理センターの契約の状況に出す、ストレージの使用量のゲージ（バー型）。<b>文言と割合はサーバが作り、ここは描くだけ</b>。
 * 割合が分からないとき（null）は塗りを出さず、文言だけ出す。
 */
export function StorageGauge({ usage }: { readonly usage: StorageUsage }): ReactElement {
    // 割合が分からないときは aria-valuenow を付けない（値の無いバー）
    return (
        <div data-storage-gauge="">
            <div
                className="gauge"
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={usage.percent ?? undefined}
                aria-label="ストレージの使用量"
            >
                <div
                    className={usage.isNearLimit ? "gauge-fill gauge-fill-warning" : "gauge-fill"}
                    style={{ width: `${String(usage.percent ?? 0)}%` }}
                />
            </div>
            <p className="mt-1 text-slate-500">{usage.label}</p>
        </div>
    );
}
